enum DocumentProtectionStatus {
  Unprotected = 'unprotected',
  Protected = 'protected',
}

export default DocumentProtectionStatus;
